/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Seo_Home_H11Inputs */

const vi_sitesettings_seo_home_h11 = /** @type {(inputs: Sitesettings_Seo_Home_H11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu đề H1 trang chủ (ẩn, cho SEO)`)
};

/**

* @param {Sitesettings_Seo_Home_H11Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_seo_home_h11 = /** @type {((inputs?: Sitesettings_Seo_Home_H11Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Seo_Home_H11Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_seo_home_h11(inputs)
});
export { sitesettings_seo_home_h11 as "siteSettings_seo_home_h1" }